import React from 'react'
import Upwork from '../../img/Upwork.png'
import Fiverr from '../../img/fiverr.png'
import Amazon from '../../img/amazon.png'
import Shopify from '../../img/Shopify.png'
import Facebook from '../../img/Facebook.png'
// import { themeContext } from '../../Context'
import { motion } from 'framer-motion'
// import { Link } from 'react-scroll'
const Works = () => {
  // context

  // transition
  return (
    <div className='works' id='works'>
      {/* left side */}
      <div className='w-left'>
        <div className='awesome'>
          {/* dark Mode */}
          <span>Works for All these</span>
          <span>Brands & Clients</span>
          <span>
            Lorem ispum is simpley dummy text of printing of printing Lorem
            <br />
            ispum is simpley dummy text of printingLorem ispum is simpley dummy
            text
            <br />
            y dummy text of printingLorem
            <br />
            ispum is simpley dummy text of printing
          </span>
          {/* <Link to='contact' smooth={true} spy={true}>
            <button className='button s-button'>Hire Me</button>
          </Link> */}
          <div
            className='blur s-blur1'
            style={{ background: '#ABF1FF94' }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className='w-right'>
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: '-40px' }}
          transition={{ duration: 3.5, type: 'spring' }}
          className='w-mainCircle'
        >
          <div className='w-secCircle'>
            <img src={Upwork} alt='' />
          </div>
          <div className='w-secCircle'>
            <img src={Fiverr} alt='' />
          </div>
          <div className='w-secCircle'>
            <img src={Amazon} alt='' />
          </div>{' '}
          <div className='w-secCircle'>
            <img src={Shopify} alt='' />
          </div>
          <div className='w-secCircle'>
            <img src={Facebook} alt='' />
          </div>
        </motion.div>
        {/* background Circles */}
        <div className='w-backCircle blueCircle'></div>
        <div className='w-backCircle yellowCircle'></div>
      </div>
    </div>
  )
}

export default Works
